import { useContext } from "react";
import { HotelContext } from "../context/hotel";
import useApi from "./useApi";
import { CheckInContext } from "../context/checkin";

const useCheckInActions = () => {
    const { data: hotel } = useContext(HotelContext);
    const { data: checkIn } = useContext(CheckInContext);
    const { get, put, post, patch } = useApi();

    const getHotelByCode = async (clientCode) => {
        try {
            const response = await get(`hotels/?code=${clientCode}`);
            return response || false;
        } catch (error) {
            console.error('Error fetching hotel by code:', error);
            return false;
        }
    };

    const identify = async (code) => {
        try {
            const response = await get(`hotels/${hotel?.id}/reservations/${code}`);
            if (response && response.id) {
                const checkin_data = await get(`hotels/${hotel?.id}/checkins/${response.id}`)
                if (checkin_data.id) {
                    // data['externalId'] = data['externalId'] || securityCode;
                    checkin_data['inStay'] = false;
                    if (checkin_data.status === 'in_stay' && checkin_data.roomOccupationId) {
                        checkin_data['inStay'] = true; //_data.id
                    }
                    checkin_data['reservation'] = JSON.parse(checkin_data.reservation);
                    checkin_data['email'] = checkin_data['email'] || '';
                    checkin_data['travelType'] = checkin_data['travelType'] || '';
                    checkin_data['extraData'] = checkin_data.extraData ? JSON.parse(checkin_data.extraData) : {};
                    checkin_data['crossUpSelling'] = Array.isArray(checkin_data.crossUpSelling)
                        ? checkin_data.crossUpSelling
                        : [];
                    checkin_data['timestamp'] = Date.now();
                    checkin_data['webCheckInDone'] = checkin_data['lastSentToReview'] || false;         // Esto traerlo desde la API
                    return checkin_data;
                }
                // return apiBffGet(`checkins/current`, true).then(data => {
                //     console.log('0407 - R2', data)
                //     if (data.id) {
                //         console.log('0407 - data', data)
                //         // data['externalId'] = data['externalId'] || securityCode;
                //         data['inStay'] = false;
                //         if (data.status === 'in_stay' && data.roomOccupationId) {
                //             data['inStay'] = true; //_data.id
                //         }
                //         data['reservation'] = JSON.parse(data.reservation);
                //         data['email'] = data['email'] || '';
                //         data['travelType'] = data['travelType'] || '';
                //         data['extraData'] = data.extraData ? JSON.parse(data.extraData) : {};
                //         data['timestamp'] = Date.now();
                //         console.log('0407 - data', data)
                //         return data;
                //     }
                //     throw new Error('checkin-not-found')

                //     }
                // )
            }
        } catch (error) {
            console.error('Error identify:', error);
            return false;
        }
        // return apiBffGet(`reservations/${code}`, true)
        //     .then(async r => {
        //         if (r.found) {
        //             console.log('0407 - R1', r)
        //             return apiBffGet(`checkins/current`, true).then(data => {
        //                 console.log('0407 - R2', data)
        //                 if (data.id) {
        //                     console.log('0407 - data', data)
        //                     // data['externalId'] = data['externalId'] || securityCode;
        //                     data['inStay'] = false;
        //                     if (data.status === 'in_stay' && data.roomOccupationId) {
        //                         data['inStay'] = true; //_data.id
        //                     }
        //                     data['reservation'] = JSON.parse(data.reservation);
        //                     data['email'] = data['email'] || '';
        //                     data['travelType'] = data['travelType'] || '';
        //                     data['extraData'] = data.extraData ? JSON.parse(data.extraData) : {};
        //                     data['timestamp'] = Date.now();
        //                     console.log('0407 - data', data)
        //                     return data;
        //                 }
        //                 throw new Error('checkin-not-found')

        //                 }
        //             )
        //         }
        //     })
        return false;
    }

    const identifyByData = async (data) => {
        let response = null;
        try {
            response = await get(`hotels/${hotel?.id}/reservations_by_data/${data}`);
            if (response && response.id) {
                const checkin_data = await get(`hotels/${hotel?.id}/checkins/${response.id}`)
                if (checkin_data.id) {
                    // data['externalId'] = data['externalId'] || securityCode;
                    checkin_data['inStay'] = false;
                    if (checkin_data.status === 'in_stay' && checkin_data.roomOccupationId) {
                        checkin_data['inStay'] = true; //_data.id
                    }
                    checkin_data['reservation'] = JSON.parse(checkin_data.reservation);
                    checkin_data['email'] = checkin_data['email'] || '';
                    checkin_data['travelType'] = checkin_data['travelType'] || '';
                    checkin_data['extraData'] = checkin_data.extraData ? JSON.parse(checkin_data.extraData) : {};
                    checkin_data['crossUpSelling'] = Array.isArray(checkin_data.crossUpSelling)
                        ? checkin_data.crossUpSelling
                        : [];
                    checkin_data['timestamp'] = Date.now();
                    checkin_data['webCheckInDone'] = checkin_data['lastSentToReview'] || false;         // Esto traerlo desde la API
                    return checkin_data;
                }
                // return apiBffGet(`checkins/current`, true).then(data => {
                //     console.log('0407 - R2', data)
                //     if (data.id) {
                //         console.log('0407 - data', data)
                //         // data['externalId'] = data['externalId'] || securityCode;
                //         data['inStay'] = false;
                //         if (data.status === 'in_stay' && data.roomOccupationId) {
                //             data['inStay'] = true; //_data.id
                //         }
                //         data['reservation'] = JSON.parse(data.reservation);
                //         data['email'] = data['email'] || '';
                //         data['travelType'] = data['travelType'] || '';
                //         data['extraData'] = data.extraData ? JSON.parse(data.extraData) : {};
                //         data['timestamp'] = Date.now();
                //         console.log('0407 - data', data)
                //         return data;
                //     }
                //     throw new Error('checkin-not-found')

                //     }
                // )
            }
        } catch (error) {
            console.error('11dic Error identify:', error);
            return false;
        }
        // return apiBffGet(`reservations/${code}`, true)
        //     .then(async r => {
        //         if (r.found) {
        //             console.log('0407 - R1', r)
        //             return apiBffGet(`checkins/current`, true).then(data => {
        //                 console.log('0407 - R2', data)
        //                 if (data.id) {
        //                     console.log('0407 - data', data)
        //                     // data['externalId'] = data['externalId'] || securityCode;
        //                     data['inStay'] = false;
        //                     if (data.status === 'in_stay' && data.roomOccupationId) {
        //                         data['inStay'] = true; //_data.id
        //                     }
        //                     data['reservation'] = JSON.parse(data.reservation);
        //                     data['email'] = data['email'] || '';
        //                     data['travelType'] = data['travelType'] || '';
        //                     data['extraData'] = data.extraData ? JSON.parse(data.extraData) : {};
        //                     data['timestamp'] = Date.now();
        //                     console.log('0407 - data', data)
        //                     return data;
        //                 }
        //                 throw new Error('checkin-not-found')

        //                 }
        //             )
        //         }
        //     })
        return response;
    }

    const refreshStatus = async (hotelId, checkInId) => {
        if (!hotelId || !checkInId) return;

        try {
            const response = await get(`hotels/${hotelId}/checkins/${checkInId}/status`);

            if (response && response.id) {
                const _newData = { ...response };
                _newData['webCheckInDone'] = _newData['lastSentToReview'] ? true : false;
                delete _newData['lastSentToReview'];
                if (_newData.reservation && typeof _newData.reservation === 'string') {
                    try {
                        _newData.reservation = JSON.parse(_newData.reservation);
                    } catch (e) {
                        console.warn('refreshStatus: reservation JSON inválido', e);
                    }
                }
                return _newData;
            }

            throw new Error('checkin-refresh-status-error');
        } catch (error) {
            console.error('Error refreshStatus:', error);
            return false;
        }
    };

    const saveCheckIn = async (data) => {
        try {
            const endpoint = `hotels/${hotel?.id}/checkins/${data.id}`;
            const response = await put(endpoint, { ...data });

            if (response) {
                return response;
            } else {
                console.error('Error saving check-in.');
            }
        } catch (error) {
            console.error('Error saving check-in:', error);
        }
    };

    const addComment = async (checkInId, comment) => {
        console.log('18ago - comment', comment)
        console.log('18ago - hotel', hotel)
        console.log('18ago - checkInId', checkInId)
        try {
            const endpoint = `hotels/${hotel?.id}/checkins/${checkInId}/messages`;
            console.log('18ago - endpoint', endpoint)
            const response = await post(endpoint, { "comment": comment });
            console.log('18ago - response', response)

            if (response) {
                return response;
            } else {
                console.error('Error comment check-in.');
            }
        } catch (error) {
            console.error('18ago - Error comment check-in:', error);
        }
    };
    const setDoNotDisturbMode = async (checkInId, state) => {
        console.log('18ago - state', state)
        console.log('18ago - hotel', hotel)
        console.log('18ago - checkInId', checkInId)
        try {
            const endpoint = `hotels/${hotel?.id}/checkins/${checkInId}/donotdisturb`;
            console.log('18ago - endpoint', endpoint)
            const response = await patch(endpoint, {"state": state });
            console.log('18ago - response', response)

            if (response) {
                return response;
            } else {
                console.error('Error doNotDisturb check-in.');
            }
        } catch (error) {
            console.error('18ago - Error doNotDisturb check-in:', error);
        }
    };

    const getBalance = async (hotelId, checkInId) => {
        if (!hotelId || !checkInId) return;

        try {
            const response = await get(`hotels/${hotelId}/checkins/${checkInId}/balance`);

            console.log('31ene - response', response)

            if (response && response.balance) {
                return response;
            }

            throw new Error('get-balance-error');
        } catch (error) {
            console.error('Error getBalance:', error);
            return false;
        }

    }

    const getAccount = async (hotelId, checkInId) => {
        if (!hotelId || !checkInId) return;

        try {
            const response = await get(`hotels/${hotelId}/checkins/${checkInId}/account`);

            console.log('31ene - response', response)

            return response

            throw new Error('get-account-error');
        } catch (error) {
            console.error('Error getAccount:', error);
            return false;
        }

    }


    return {
        identify,
        identifyByData,
        refreshStatus,
        saveCheckIn,
        getBalance,
        getAccount,
        addComment,
        setDoNotDisturbMode
    }

}

export default useCheckInActions;